var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ojete-vozidlo-select',{attrs:{"text":_vm.OvozidloIdText,"mutation-name":_vm.mutationsMappers.mutationName,"action-name":_vm.actionsMapper.actionName},on:{"update:text":function($event){_vm.OvozidloIdText=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }